
import { Component, Mixins, Watch } from "vue-property-decorator";

@Component({
})
export default class ReceptionDetailPaneMixin extends Mixins() {
  data() {
    return {
      windowWidth: document.documentElement.clientWidth,
      automaticallyChecked: false,
      isSelectedRightSide: true,
    };
  }
  windowWidth: number;
  automaticallyChecked: boolean;
  isSelectedRightSide: boolean;

  get automaticSwitchingWidth(): number {
    return this.$configuration.behavior.reception.list.panes.automaticSwitchingWidth;
  }

  get shouldShowAutomatically(): boolean {
    return (0 < this.automaticSwitchingWidth);
  }

  get shouldShowCommentRightSide(): boolean {
    return this.automaticallyChecked
        ? this.isSelectedRightSideAutomatically
        : this.isSelectedRightSide;
  }

  get isSelectedRightSideAutomatically(): boolean {
    return (this.automaticSwitchingWidth < this.windowWidth);
  }

  get tabLayoutClass(): string {
    return this.shouldShowCommentRightSide
      ? "horizontal"
      : "vertical";
  }

  mounted() {
    this.automaticallyChecked = this.shouldShowAutomatically;
    window.addEventListener("resize", this.onWindowResized);
  }

  onWindowResized(): void {
    this.windowWidth = document.documentElement.clientWidth;
  }

  automaticallyUpdated(): void {
    this.automaticallyChecked = !this.automaticallyChecked;
  }

  splitUpdated(): void {
    this.isSelectedRightSide = !this.isSelectedRightSide;
  }

  @Watch("automaticallyChecked")
  onAutomaticallyCheckedChanged(newValue: boolean, oldValue: boolean) {
    if (!newValue) {
      this.isSelectedRightSide = this.isSelectedRightSideAutomatically;
    }
  }
}
